import React, { forwardRef, useState } from 'react';
import SidebarDrawer, { SidebarDrawerProps } from './components/SidebarDrawer';
import useStyles from './styles';
export type { Links, LinkEvent } from './components/types';

export interface SidebarProps extends Omit<SidebarDrawerProps, 'options' | 'setOptions'> {
    children?: React.ReactNode;
    isOpen?: boolean;
}

const Sidebar = forwardRef<HTMLDivElement, SidebarProps>(function Sidebar(props, ref) {
    const {
        children,
        isOpen = true,
        menu,
        paddingLeftOnOpen = true,
        paddingTop = 10,
        version,
        enableColorDark,
        NavLink,
        onClickMenuItem,
    } = props;

    const [options, setOptions] = useState({ isOpen, isOpenFromMenu: !isOpen });

    const classes = useStyles({ isOpen: options.isOpen, paddingTop, paddingLeftOnOpen });

    return (
        <div ref={ref} className={classes.sidebar}>
            <SidebarDrawer
                enableColorDark={enableColorDark}
                menu={menu}
                version={version}
                options={options}
                setOptions={setOptions}
                NavLink={NavLink}
                onClickMenuItem={onClickMenuItem}
            />
            {children ? <div className={classes.application}>{children}</div> : null}
        </div>
    );
});

export default Sidebar;
